import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyEmbeddedPostRsvpFunnel = loadable(
  () => import(/* webpackChunkName: "content/guest/embedded-post-rsvp-funnel" */ './EmbeddedPostRsvpFunnel'),
  'EmbeddedPostRsvpFunnel',
);
